
export default {
    name: 'SvgSwiftTrailerDriver',
};
